export const workflows = {
  vulnerableTechnology: {
    nodes: [
      {
        type: 'node',
        size: '100*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Vulnerable\r\n Technology',
        x: 50,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '60*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Validate',
        x: 150,
        y: 170,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '70*70',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Exploitable',
        x: 230,
        y: 170,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 320,
        y: 110,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 320,
        y: 220,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '60*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Suppress',
        x: 400,
        y: 110,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '90*90',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Protected\r\n by\r\n WAF',
        x: 400,
        y: 220,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 490,
        y: 170,
        id: '7',
        index: 7,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 490,
        y: 270,
        id: '8',
        index: 8,
      },
      {
        type: 'node',
        size: '80*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notify WAF\r\n Provider',
        x: 600,
        y: 270,
        id: '9',
        index: 9,
      },
      {
        type: 'node',
        size: '110*30',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Move behind WAF',
        x: 600,
        y: 170,
        id: '10',
        index: 10,
      },
      {
        type: 'node',
        size: '80*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notify Slack',
        x: 230,
        y: 320,
        id: '11',
        index: 11,
      },
      {
        type: 'node',
        size: '100*25',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Cron Job',
        x: 50,
        y: 230,
        id: '24',
        index: 24,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '13',
        index: 13,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '15',
        index: 15,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '17',
        index: 17,
      },
      {
        source: '4',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '18',
        index: 18,
      },
      {
        source: '6',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '19',
        index: 19,
      },
      {
        source: '6',
        sourceAnchor: 1,
        target: '8',
        targetAnchor: 3,
        id: '20',
        index: 20,
      },
      {
        source: '7',
        sourceAnchor: 1,
        target: '10',
        targetAnchor: 3,
        id: '21',
        index: 21,
      },
      {
        source: '8',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '22',
        index: 22,
      },
      {
        source: '2',
        sourceAnchor: 2,
        target: '11',
        targetAnchor: 0,
        id: '23',
        index: 23,
      },
    ],
  },
  newWebsiteDiscovered: {
    nodes: [
      {
        type: 'node',
        size: '180*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'New Website Discovered',
        x: 100,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '190*30',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Run Discovery Scan',
        x: 350,
        y: 100,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '120*120',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Behind WAF?',
        x: 550,
        y: 100,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 670,
        y: 50,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 670,
        y: 130,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '190*50',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Run VA Scan',
        x: 880,
        y: 50,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '120*120',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'High\r\n Vulnerability\r\n Detected?',
        x: 550,
        y: 250,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 670,
        y: 210,
        id: '7',
        index: 7,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 670,
        y: 300,
        id: '8',
        index: 8,
      },
      {
        type: 'node',
        size: '190*50',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notification By Slack & Email',
        x: 880,
        y: 300,
        id: '9',
        index: 9,
      },
      {
        type: 'node',
        size: '210*30',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Set Automatic VA for every two weeks',
        x: 350,
        y: 250,
        id: '10',
        index: 10,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '11',
        index: 11,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '12',
        index: 12,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '13',
        index: 13,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '15',
        index: 15,
      },
      {
        source: '0',
        sourceAnchor: 1,
        target: '10',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
      {
        source: '10',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '17',
        index: 17,
      },
      {
        source: '6',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '18',
        index: 18,
      },
      {
        source: '6',
        sourceAnchor: 1,
        target: '8',
        targetAnchor: 3,
        id: '19',
        index: 19,
      },
      {
        source: '8',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '20',
        index: 20,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 0,
        id: '21',
        index: 21,
      },
    ],
  },
  newSubdomainDiscovered: {
    nodes: [
      {
        type: 'node',
        size: '180*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'New Subdomain Discovered',
        x: 100,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '90*50',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Run Hijack Scan',
        x: 280,
        y: 100,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '90*50',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Run Deep-Scan',
        x: 280,
        y: 250,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '120*120',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Hijackable?',
        x: 450,
        y: 100,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 570,
        y: 50,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 570,
        y: 130,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '150*30',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Run Automatic Takeover',
        x: 750,
        y: 170,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '120*120',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Port 3389/RDP\r\n open?',
        x: 450,
        y: 250,
        id: '7',
        index: 7,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 570,
        y: 210,
        id: '8',
        index: 8,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 570,
        y: 300,
        id: '9',
        index: 9,
      },
      {
        type: 'node',
        size: '190*50',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notification By Slack & Email',
        x: 750,
        y: 300,
        id: '10',
        index: 10,
      },
      {
        type: 'node',
        size: '150*30',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notification Slack',
        x: 750,
        y: 90,
        id: '22',
        index: 22,
      },
      {
        type: 'node',
        size: '150*30',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notification Email',
        x: 750,
        y: 130,
        id: '23',
        index: 23,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '11',
        index: 11,
      },
      {
        source: '0',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '12',
        index: 12,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '13',
        index: 13,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '15',
        index: 15,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '17',
        index: 17,
      },
      {
        source: '7',
        sourceAnchor: 1,
        target: '8',
        targetAnchor: 3,
        id: '18',
        index: 18,
      },
      {
        source: '7',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '19',
        index: 19,
      },
      {
        source: '9',
        sourceAnchor: 1,
        target: '10',
        targetAnchor: 3,
        id: '20',
        index: 20,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '22',
        targetAnchor: 3,
        id: '24',
        index: 24,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '23',
        targetAnchor: 3,
        id: '25',
        index: 25,
      },
    ],
  },
  newEmployeeLeakDetected: {
    nodes: [
      {
        type: 'node',
        size: '180*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Credentials Leaks Discovered',
        x: 100,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '90*50',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Notification',
        x: 280,
        y: 170,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Create Task',
        x: 400,
        y: 170,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 520,
        y: 130,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 520,
        y: 210,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Create Task',
        x: 640,
        y: 210,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 740,
        y: 170,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 740,
        y: 250,
        id: '7',
        index: 7,
      },
      {
        type: 'node',
        size: '90*50',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Verify',
        x: 860,
        y: 210,
        id: '8',
        index: 8,
      },
      {
        type: 'node',
        size: '90*50',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Manual Review',
        x: 860,
        y: 290,
        id: '9',
        index: 9,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '12',
        index: 12,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '17',
        index: 17,
      },
      {
        source: '4',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '18',
        index: 18,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '19',
        index: 19,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '20',
        index: 20,
      },
      {
        source: '7',
        sourceAnchor: 1,
        target: '8',
        targetAnchor: 3,
        id: '21',
        index: 21,
      },
      {
        source: '7',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '22',
        index: 22,
      },
    ],
  },
  notify: {
    nodes: [
      {
        type: 'node',
        size: '140*70',
        shape: 'flow-rect',
        color: '#ff7f00',
        label: 'Notify',
        x: 100,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '110*40',
        shape: 'flow-rect',
        color: '#ff7f00',
        label: 'Process Completed',
        x: 300,
        y: 130,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '110*40',
        shape: 'flow-rect',
        color: '#ff7f00',
        label: 'Security Event',
        x: 300,
        y: 210,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '100*40',
        shape: 'flow-rect',
        color: '#2baf69',
        label: 'Successful',
        x: 480,
        y: 105,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '100*40',
        shape: 'flow-rect',
        color: '#e0255e',
        label: 'Failed',
        x: 480,
        y: 150,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '110*40',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notification',
        x: 480,
        y: 210,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Create Task',
        x: 600,
        y: 210,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 700,
        y: 180,
        id: '7',
        index: 7,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 700,
        y: 260,
        id: '8',
        index: 8,
      },
      {
        type: 'node',
        size: '110*40',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Notification',
        x: 620,
        y: 130,
        id: '9',
        index: 9,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Create Task',
        x: 790,
        y: 130,
        id: '10',
        index: 10,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 900,
        y: 105,
        id: '11',
        index: 11,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 900,
        y: 180,
        id: '12',
        index: 12,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '13',
        index: 13,
      },
      {
        source: '0',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '15',
        index: 15,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '17',
        index: 17,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '18',
        index: 18,
      },
      {
        source: '4',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '19',
        index: 19,
      },
      {
        source: '9',
        sourceAnchor: 1,
        target: '10',
        targetAnchor: 3,
        id: '20',
        index: 20,
      },
      {
        source: '10',
        sourceAnchor: 1,
        target: '11',
        targetAnchor: 3,
        id: '21',
        index: 21,
      },
      {
        source: '10',
        sourceAnchor: 1,
        target: '12',
        targetAnchor: 3,
        id: '22',
        index: 22,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '23',
        index: 23,
      },
      {
        source: '6',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '24',
        index: 24,
      },
      {
        source: '6',
        sourceAnchor: 1,
        target: '8',
        targetAnchor: 3,
        id: '25',
        index: 25,
      },
    ],
  },
  vulnerabilityDiscovered: {
    nodes: [
      {
        type: 'node',
        size: '140*70',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Vulnerability Discovered',
        x: 100,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '100*50',
        shape: 'flow-rect',
        color: '#e0255e',
        label: 'High',
        x: 300,
        y: 110,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '100*50',
        shape: 'flow-rect',
        color: '#FA8C16',
        label: 'Medium',
        x: 300,
        y: 170,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '100*50',
        shape: 'flow-rect',
        color: '#2baf69',
        label: 'Low',
        x: 300,
        y: 230,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '90*50',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Notification',
        x: 480,
        y: 170,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Create Task',
        x: 600,
        y: 170,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 680,
        y: 130,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 680,
        y: 210,
        id: '7',
        index: 7,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '8',
        index: 8,
      },
      {
        source: '0',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '9',
        index: 9,
      },
      {
        source: '0',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '10',
        index: 10,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '11',
        index: 11,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '12',
        index: 12,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '13',
        index: 13,
      },
      {
        source: '4',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '15',
        index: 15,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
    ],
  },
  leaksDiscovered: {
    nodes: [
      {
        type: 'node',
        size: '180*60',
        shape: 'flow-rect',
        color: '#A9B6C3',
        label: 'Data Leaks Discovered',
        x: 100,
        y: 170,
        id: '0',
        index: 0,
      },
      {
        type: 'node',
        size: '100*30',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Slack Notification',
        x: 320,
        y: 120,
        id: '1',
        index: 1,
      },
      {
        type: 'node',
        size: '100*30',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Email Notification',
        x: 320,
        y: 210,
        id: '19',
        index: 19,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Github',
        x: 450,
        y: 170,
        id: '2',
        index: 2,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 550,
        y: 130,
        id: '3',
        index: 3,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 550,
        y: 210,
        id: '4',
        index: 4,
      },
      {
        type: 'node',
        size: '80*80',
        shape: 'flow-rhombus',
        color: '#13C2C2',
        label: 'Pastebin',
        x: 680,
        y: 130,
        id: '5',
        index: 5,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'No',
        x: 780,
        y: 90,
        id: '6',
        index: 6,
      },
      {
        type: 'node',
        size: '50*50',
        shape: 'flow-circle',
        color: '#FA8C16',
        label: 'Yes',
        x: 780,
        y: 160,
        id: '7',
        index: 7,
      },
      {
        type: 'node',
        size: '140*30',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Generate data removal\r\n from Pastebin',
        x: 900,
        y: 160,
        id: '9',
        index: 9,
      },
      {
        type: 'node',
        size: '110*30',
        shape: 'flow-rect',
        color: '#1890FF',
        label: 'Open Jira Ticket',
        x: 700,
        y: 210,
        id: '22',
        index: 22,
      },
    ],
    edges: [
      {
        source: '0',
        sourceAnchor: 1,
        target: '1',
        targetAnchor: 3,
        id: '10',
        index: 10,
      },
      {
        source: '0',
        sourceAnchor: 1,
        target: '19',
        targetAnchor: 3,
        id: '20',
        index: 20,
      },
      {
        source: '19',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '21',
        index: 21,
      },
      {
        source: '4',
        sourceAnchor: 1,
        target: '22',
        targetAnchor: 3,
        id: '23',
        index: 23,
      },
      {
        source: '1',
        sourceAnchor: 1,
        target: '2',
        targetAnchor: 3,
        id: '11',
        index: 11,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '3',
        targetAnchor: 3,
        id: '12',
        index: 12,
      },
      {
        source: '2',
        sourceAnchor: 1,
        target: '4',
        targetAnchor: 3,
        id: '13',
        index: 13,
      },
      {
        source: '3',
        sourceAnchor: 1,
        target: '5',
        targetAnchor: 3,
        id: '14',
        index: 14,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '6',
        targetAnchor: 3,
        id: '15',
        index: 15,
      },
      {
        source: '5',
        sourceAnchor: 1,
        target: '7',
        targetAnchor: 3,
        id: '16',
        index: 16,
      },
      {
        source: '7',
        sourceAnchor: 1,
        target: '9',
        targetAnchor: 3,
        id: '17',
        index: 17,
      },
    ],
  },
};

export default workflows;
